import 'leaflet'
import baseMap from "../app/geo/mixins/base-map.js"
import url from '../utils/url.js'
import ObjectsSupeclasterLayerDrawer from '../utils/map/superclaster/ObjectsSupeclasterLayerDrawer'
import BaseLayerDrawer from '../utils/map/BaseLayerDrawer.js'
import {OBJECT_RENDERER} from "../config/config"

export default {
  data () {
    this.mapLayers = null;
    return {
      layersLoading: false,
      layers: [],
      showedStatus: [],
    }
  },
  mixins: [baseMap],
  computed: {
    status() {
      return this.showedStatus || []
    },
    showMapLegend: {
      get () {
        return this.$store.state.showMapLegend
      },
      set (value) {
        this.$store.commit('mapLegend', value)
      }
    },
    layersConf() {
      return this.getLayersConf()
    },
  },
  created () {
    this.subsForm = this.$emitter.listen('form', (e) => this.onFormEvent(e))
  },
  destroyed () {
    this.subsForm.unsubscribe();
    // clean saved layers data
    this.$store.commit('cleanCache')
  },
  methods: {
    showStatus() {
      this.replaceRoute({status: this.status}, false)
    },
    initObjectsLayerDrawer () {
      if (OBJECT_RENDERER === 'superclaster') {
        this.objectsLayerDrawer = new ObjectsSupeclasterLayerDrawer(this.map, {vm: this})
      } else {
        this.objectsLayerDrawer = new BaseLayerDrawer(this.map, {vm: this})
      }
      this.mapLayers = this.objectsLayerDrawer.setLayersConfigAndDraw(this.layersConf)
    },
    getPreferCanvas () {
      return false
    },
    onFormEvent (e) {
      if (e.action == 'onSaveForm' || e.action == 'onRemove') {
        this.reCreateMap()
      }
    },
    /**
     * Need for show changes after postion of marker changed
     */
    reCreateMap () {
      this.$store.commit('cleanCache');
      this.$store.commit('skipAsyncData', {name: `${this.module}.*`, depth: 1, value: false});
      this.afterReCreateMap()
    },
    afterReCreateMap () {
      console.error('Please define method afterReCreateMap')
    },
    onLayersChange(item, name, rootGroupName) {
      if (item.hasOwnProperty('groups')) {
        let parentExist = this.layers.indexOf(name) > -1;
        for (let groupItemName in item.groups) {
          // if parent check add all
          if (parentExist && this.layers.indexOf(groupItemName) === -1) {
            this.layers.push(groupItemName)
          }
          // uncheck all if parent uncheked
          if (!parentExist && this.layers.indexOf(groupItemName) > -1) {
            this.layers = this.layers.filter(v => v !== groupItemName)
          }
        }
      } else {
        let itemExist = this.layers.indexOf(name) > -1;
        if (!itemExist) {
          // uncheck parent
          this.layers = this.layers.filter(v => v !== rootGroupName)
        } else {
          if (this.layersConf[rootGroupName]) {
            // check: all sub item of group checked
            let allChecked = true;
            for (let groupItemName in this.layersConf[rootGroupName].groups) {
              if (this.layers.indexOf(groupItemName) === -1) {
                allChecked = false
              }
            }
            // remove root
            console.log('allChecked', allChecked, this.layersConf[rootGroupName]);
            if (allChecked === false) {
              this.layers = this.layers.filter(v => v !== rootGroupName)
            } else if (this.layers.indexOf(rootGroupName) === -1) {
              // add root if not exist
              this.layers.push(rootGroupName)
            }
          }
        }
      }
      this.$bar.start().set(12);
      this.layersLoading = true;
      setTimeout(() => {
        let params = {layers: this.layers};
        params.showDeleted = this.layers.length > 0 && item.hasOwnProperty('showDeleted') && item.showDeleted;
        this.replaceRoute(params, false)
      }, 50)
      this.$bar.finish()
    },
    routeHandler(newVal, oldVal){
      this.setFiltersFromUrl();
      this.layersLoading = false;
      this.setDataToLayersFromStore(this.$store.getters.skipAsyncData(this.$route.name))
    },
    setFiltersFromUrl(){
      if(this.$route.query.layers){
        let route = url.getRoute(this.$route);
        if(typeof route.query['layers'] === 'string'){
          this.layers = route.query['layers'].split(',')
        }
      }
      if(this.$route.query.status){
        let route = url.getRoute(this.$route);
        if(typeof route.query['status'] === 'string'){
          this.showedStatus = route.query['status'].split(',')
        }
      }
    },
    getCopyWithoutObservers(data){
      return JSON.parse(JSON.stringify(data))
    },
    //TODO вынести этот метод в маркер и вызывать у маркера
    getMarkerHash(marker){
      if(marker && marker.options){
        let id = marker.options.id || marker.id;
        let lat = marker.options.model.lat || marker.options.model.latitude;
        let lng = marker.options.model.lng || marker.options.model.longitude;
        return `${id},${lat},${lng}`
      }
      return ``
    },
    getOpenedMarkerInfo () {
      let id, lat, lng, type;
      if (this.$route.query.openedPopupInfo) {
        ([id, lat, lng] = this.$route.query.openedPopupInfo.split(','))
      }
      return {id, lat, lng, type}
    },
    getParentsConf(layersArr, conf) {
      let parents = {};
      for (let key in conf) {
        if (layersArr.indexOf(key) > -1) {
          parents[key] = conf[key]
        }

        if (conf[key].hasOwnProperty('groups')) {
          for (let childKey in conf[key].groups) {
            if (layersArr.indexOf(childKey) > -1) {
              parents[key] = conf[key]
            }
          }
        }
      }

      return parents
    },
    getLayerEndpoint (conf, type, route) {
      if (conf[type] && conf[type].endpoint) {
        return conf[type].endpoint(route)
      }
      return null
    },
    setDataToLayersFromStore(lazyRestore = false){
      if(this.mapLayers) {
        let conf = this.getParentsConf(this.layers, this.getLayersConf());
        let time = +new Date();
        for(let type in this.mapLayers){
          if(conf.hasOwnProperty(type)){
            let endpoint = this.getLayerEndpoint(conf, type, this.$route);
            if(!lazyRestore || !this.mapLayers[type]._data){
              let data = this.getCopyWithoutObservers(this.$store.getters.readUrlEndpoint(endpoint));
              if (type === 'transport') {
                this.mapLayers[type]._data = {'1': data}
              } else {
                this.mapLayers[type]._data = data
              }
            }
            Object.keys(this.mapLayers[type]._layers).forEach((v, i) => {
              if(this.mapLayers[type]._data){
                this.mapLayers[type]._data[v] = this.mapLayers[type]._data[v] || [];
                let subLayer = this.mapLayers[type]._layers[v];
                if(this.layers.indexOf(subLayer.checkbox) > -1){
                  if(!lazyRestore || !this.mapLayers[type]._layers[v]._data){
                    this.mapLayers[type]._layers[v]._data = this.mapLayers[type]._data[v] || []
                  }
                  this.mapLayers[type].showLayer(v)
                }else{
                  if(!lazyRestore || !this.mapLayers[type]._layers[v]._data) {
                    this.mapLayers[type].hideLayer(v)
                  }
                }
              }
            })
          }else{
            Object.keys(this.mapLayers[type]._layers).forEach((v, i) => {
              this.mapLayers[type].hideLayer(v)
            })
          }
        }
      }
    },
    /* required for use in map-poup.vue */
    popupIsOpened(markerInfo){
      let usedRoute = url.getPrevOrCurrentRoute(this.$route);

      return usedRoute.query.openedPopupInfo === this.getMarkerHash(markerInfo)
    },
    /* required for use in map-poup.vue */
    registerOpenPopup(markerInfo){
      let openedPopupInfo = this.getMarkerHash(markerInfo);

      this.replaceRoute({openedPopupInfo: openedPopupInfo})
    }
  }
}
